// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"a568ed10","498":"46118096","513":"d6e9355c","787":"0c40ae57"}[chunkId] + ".chunk.js";
};